export const HEADERS = {
  TSS_SHELL: 'X-TSS_SHELL',
} as const
